import * as Highcharts from 'highcharts';
import highchartsExporting from 'highcharts/modules/exporting';
import highchartsExportData from 'highcharts/modules/export-data';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import Chart from '../common/Chart';
import ChartProvider from '../../contexts/ChartContext';
import { Solution } from '../../models/Models';
dayjs.extend(dayOfYear);

highchartsExporting(Highcharts);
highchartsExportData(Highcharts);
noDataToDisplay(Highcharts);

type Props = {
  reference: any;
  solutions: any;
};

const ProductionChart = ({ reference, solutions }: Props) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    //if (data?.hasOwnProperty('daily') && data?.daily?.hasOwnProperty('values') && data?.daily?.hasOwnProperty('times')) {
    if (solutions.length) {
      prepareData();
    }
    //}
  }, [reference, solutions]);

  const prepareData = () => {
    let dataObject = {
      times: [],
      values: {},
      units: {},
      title: 'Production',
      xTitle: 'Production (MWh/day)',
    };
    dataObject['times'] = reference?.times;
    dataObject['values'] = {
      production: reference?.values?.production,
      no_soiling_production: reference?.values?.no_soiling_production,
    };
    dataObject['units'] = reference?.units;
    solutions?.forEach((item: Solution) => {
      dataObject['values'][item.name + '_production'] = item?.data?.daily?.values?.production;
      dataObject['units'][item.name + '_production'] = item?.data?.daily?.units?.production;
    });
    setData(dataObject);
  };

  return (
    <>
      <Box sx={{ /*display: 'flex',*/ justifyContent: 'center', pl: 1, pr: 1 }}>
        {reference && (
          <>
            <ChartProvider>
              <Box>
                <Chart data={data} />
              </Box>
            </ChartProvider>
          </>
        )}
      </Box>
    </>
  );
};

export default ProductionChart;
